import { IPagination } from "src/common/types";

// 列表数据类型
export interface PayListType {
  batchNo: string
  channelId: number,
  checkSNum: number,
  checkSalaryAmount: string;
  checkTotalNum: number;
  createTime: string;
  failCheckNum: number;
  failNum: number;
  rejectRemark: string;
  remark: string;
  serviceCharge: string;
  shoudPayAmount: string;
  specifyPayDate: string;
  statusDesc: string;
  statusId: string;
  succCheckNum: number;
  succNum: number;
  totalNum: number;
}

// 图片类型
export interface ImageType {
  imageName: string;
  imageSize: number;
  imageUrl: string;
}

// 发放类型
export interface PayType {
  batchNo: string;
  totalAmount: number;
  totalNum: number;
  filePath: string;
  payDate: string;
  bizLine: number;
  tempUrl: string;
  tempFields: string;
  isShowNew: boolean;
  isShowModal: boolean;
  fileName: string;
  size: number,
  imageList: ImageType[];
  dataSource: number;
  channelId: number;
}

// loading类型
export interface LoadingType {
  showA: boolean;
  showB: boolean;
  text: string;
  second: number;
}

// 状态下拉列表类型
export interface StatusType {
  code: string;
  statusDesc: string;
}

// 导出类型
export interface ExportType {
  showRate: boolean;
  rate: number;
}

// action类型枚举
export const enum PayActionTypes {
  
  // 查询发放列表
  FETCH_QUERY_PAY_LIST = "@@pay_list/FETCH_QUERY_PAY_LIST",
  FETCH_QUERY_PAY_LIST_FINISH = "@@pay_list/FETCH_QUERY_PAY_LIST_FINISH",

  // loading
  FETCH_LOADING = "@@loading/FETCH_LOADING",

  // 创建发放时获取批次号
  FETCH_QUERY_BATCH = "@@pay_batch/FETCH_QUERY_BATCH",

  // 查询是否有名单模板
  FETCH_QUERY_TEMP_URL = "@@pay_tempUrl/FETCH_QUERY_TEMP_URL",

  // 下载模板
  FETCH_DOWNLOAD_TEMP = "@@pa_download/FETCH_DOWNLOAD_TEMP",

  // onePay字段内容赋值
  FETCH_QUERY_ONEPAY_FINISH = "@@pay_new/FETCH_QUERY_ONEPAY_FINISH",

  // 确认发放、撤销发放、保存凭证
  FETCH_COMMON = "@@pay_common/FETCH_COMMON",

  // 创建发放
  FETCH_APPLY_PAY = "@@pay_apply/FETCH_APPLY_PAY",

  // 查询状态下拉列表
  FETCH_STATUS_LIST = "@@pay_status/FETCH_STATUS_LIST",
  FETCH_STATUS_LIST_FINISH = "@@pay_status/FETCH_STATUS_LIST_FINISH",

  // 查看凭证
  FETCH_QUERY_IMAGE = "@@pay_image/FETCH_QUERY_IMAGE",

  // 导出获取taskId
  FETCH_EXPORT_EXCEL = "@@export_excel/FETCH_EXPORT_EXCEL",

  // 根据taskId轮询导出
  FETCH_EXPORT_BY_TASKID = "@@export_by_taskid/FETCH_EXPORT_BY_TASKID",
  FETCH_EXPORT_BY_TASKID_FINISH = "@@export_by_taskid/FETCH_EXPORT_BY_TASKID_FINISH",

  // 点击放大图片
  FETCH_SHOW_PIC = "@@show_pic/FETCH_SHOW_PIC"
  
};

export interface PayState {
  payList: PayListType[];
  loading: LoadingType;
  pagination: IPagination;
  onePay: PayType;
  statusList: StatusType[];
  exportExcel: ExportType;
  isShowPic: boolean;
}


// WEBPACK FOOTER //
// ./src/store/pay/types.ts